import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.h1`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => (props.theme.isMobile ? props.theme.fontWeightHeavy : props.theme.fontWeightBold)};
  font-size: ${props => (props.theme.isMobile ? 26 : 32)}px;
  line-height: ${props => (props.theme.isMobile ? 123 : 100)}%;
  color: ${props => props.theme.bodyColor};
  margin: 0;
  ${props => props.theme.isFeaturedLarge && `
    margin-right: 48px;
  `};
`;

export default function Name({ name }) {
  return <Text>{name}</Text>;
}

Name.propTypes = { name: PropTypes.string.isRequired };
